/**
 * @generated by `astryx theme build` — do not edit manually.
 * Source: src/theme/madhani.ts
 * Command: astryx theme build src/theme/madhani.ts
 * CLI: @astryxdesign/cli@0.5.2
 * Core: @astryxdesign/core@0.5.2
 */

/**
 * madhani theme — built by `pnpm exec astryx theme build`
 * Import the CSS file alongside this module:
 *
 *   import { madhaniTheme } from './madhani';
 *   import './madhani.css';
 */
export const madhaniTheme = {
  name: 'madhani',
  __built: true,
  tokens: {
    "--color-accent": "light-dark(#00688B, #00D9FF)",
    "--color-accent-muted": "light-dark(color-mix(in srgb, var(--color-accent) 20%, transparent), color-mix(in srgb, var(--color-accent) 25%, transparent))",
    "--color-on-accent": "light-dark(#FFFFFF, #00394B)",
    "--color-neutral": "light-dark(#141D211A, #D8E5E933)",
    "--color-background-surface": "light-dark(#F6FDFF, #131D20)",
    "--color-background-body": "light-dark(#E7F2F9, #051316)",
    "--color-overlay": "light-dark(#141D2166, #131D2099)",
    "--color-overlay-hover": "light-dark(#141D210D, #FFFFFF0D)",
    "--color-overlay-pressed": "light-dark(#141D211A, #FFFFFF1A)",
    "--color-background-muted": "light-dark(#141D210D, #131D2080)",
    "--color-text-primary": "light-dark(#000000, #F4FEFF)",
    "--color-text-secondary": "light-dark(#23323A, #B5CAD0)",
    "--color-text-disabled": "light-dark(#82939D, #4E6167)",
    "--color-text-accent": "var(--color-accent)",
    "--color-icon-accent": "var(--color-accent)",
    "--color-icon-primary": "light-dark(#000000, #F4FEFF)",
    "--color-icon-secondary": "light-dark(#23323A, #B5CAD0)",
    "--color-icon-disabled": "light-dark(#82939D, #4E6167)",
    "--color-background-card": "light-dark(#F6FDFF, #131D20)",
    "--color-background-popover": "light-dark(#F6FDFF, #283235)",
    "--color-background-inverted": "light-dark(#141D21, #F4FEFF)",
    "--color-border": "light-dark(#141D2133, #E6F3F733)",
    "--color-border-emphasized": "light-dark(#697983, #677A80)",
    "--color-skeleton": "light-dark(#9DAEB7, #374A4F)",
    "--color-track": "light-dark(#9DAEB7, #374A4F)",
    "--color-shadow": "light-dark(#0000001A, #0000004D)",
    "--color-tint-hover": "light-dark(black, white)",
    "--font-size-4xs": "0.375rem",
    "--font-size-3xs": "0.4375rem",
    "--font-size-2xs": "0.5rem",
    "--font-size-xs": "0.625rem",
    "--font-size-sm": "0.75rem",
    "--font-size-base": "0.875rem",
    "--font-size-lg": "1.0625rem",
    "--font-size-xl": "1.25rem",
    "--font-size-2xl": "1.5rem",
    "--font-size-3xl": "1.8125rem",
    "--font-size-4xl": "2.1875rem",
    "--font-size-5xl": "2.625rem",
    "--text-heading-1-size": "var(--font-size-2xl)",
    "--text-heading-1-weight": "var(--font-weight-bold)",
    "--text-heading-1-leading": "1.3333",
    "--text-heading-2-size": "var(--font-size-xl)",
    "--text-heading-2-weight": "var(--font-weight-bold)",
    "--text-heading-2-leading": "1.4",
    "--text-heading-3-size": "var(--font-size-lg)",
    "--text-heading-3-weight": "var(--font-weight-semibold)",
    "--text-heading-3-leading": "1.4118",
    "--text-heading-4-size": "var(--font-size-base)",
    "--text-heading-4-weight": "var(--font-weight-semibold)",
    "--text-heading-4-leading": "1.4286",
    "--text-heading-5-size": "var(--font-size-sm)",
    "--text-heading-5-weight": "var(--font-weight-semibold)",
    "--text-heading-5-leading": "1.6667",
    "--text-heading-6-size": "var(--font-size-xs)",
    "--text-heading-6-weight": "var(--font-weight-semibold)",
    "--text-heading-6-leading": "1.6",
    "--text-body-size": "var(--font-size-base)",
    "--text-body-weight": "var(--font-weight-normal)",
    "--text-body-leading": "1.4286",
    "--text-large-size": "var(--font-size-lg)",
    "--text-large-weight": "var(--font-weight-semibold)",
    "--text-large-leading": "1.4118",
    "--text-label-size": "var(--font-size-base)",
    "--text-label-weight": "var(--font-weight-medium)",
    "--text-label-leading": "1.4286",
    "--text-code-size": "var(--font-size-base)",
    "--text-code-weight": "var(--font-weight-normal)",
    "--text-code-leading": "1.4286",
    "--text-supporting-size": "var(--font-size-sm)",
    "--text-supporting-weight": "var(--font-weight-normal)",
    "--text-supporting-leading": "1.6667",
    "--text-display-1-size": "var(--font-size-5xl)",
    "--text-display-1-weight": "var(--font-weight-normal)",
    "--text-display-1-leading": "1.2381",
    "--text-display-2-size": "var(--font-size-4xl)",
    "--text-display-2-weight": "var(--font-weight-normal)",
    "--text-display-2-leading": "1.2571",
    "--text-display-3-size": "var(--font-size-3xl)",
    "--text-display-3-weight": "var(--font-weight-normal)",
    "--text-display-3-leading": "1.3793",
    "--radius-none": "0px",
    "--radius-inner": "3px",
    "--radius-element": "6px",
    "--radius-container": "9px",
    "--radius-page": "21px",
    "--radius-chat": "21px",
    "--radius-full": "9999px",
    "--duration-fast-min": "95ms",
    "--duration-fast": "125ms",
    "--duration-fast-max": "165ms",
    "--duration-medium-min": "225ms",
    "--duration-medium": "300ms",
    "--duration-medium-max": "400ms",
    "--font-family-body": "\"Plus Jakarta Sans\", -apple-system, system-ui, 'Segoe UI', Roboto, sans-serif",
    "--font-family-heading": "\"Plus Jakarta Sans\", -apple-system, system-ui, 'Segoe UI', sans-serif",
    "--font-family-code": "\"IBM Plex Mono\", 'SF Mono', ui-monospace, Menlo, monospace",
    "--color-success": "light-dark(#1E7A28, #7FD98A)",
    "--color-on-success": "light-dark(#FFFFFF, #0B1F0D)",
    "--color-warning": "light-dark(#8A5A00, #FFC94D)",
    "--color-on-warning": "light-dark(#FFFFFF, #241800)",
    "--focus-outline-color": "var(--color-accent)"
  },
  components: {
    "heading": {
      "level:1": {
        "fontFamily": "var(--font-family-heading)",
        "fontSize": "var(--text-heading-1-size)",
        "fontWeight": "var(--text-heading-1-weight)",
        "lineHeight": "var(--text-heading-1-leading)"
      },
      "level:2": {
        "fontFamily": "var(--font-family-heading)",
        "fontSize": "var(--text-heading-2-size)",
        "fontWeight": "var(--text-heading-2-weight)",
        "lineHeight": "var(--text-heading-2-leading)"
      },
      "level:3": {
        "fontFamily": "var(--font-family-heading)",
        "fontSize": "var(--text-heading-3-size)",
        "fontWeight": "var(--text-heading-3-weight)",
        "lineHeight": "var(--text-heading-3-leading)"
      },
      "level:4": {
        "fontFamily": "var(--font-family-heading)",
        "fontSize": "var(--text-heading-4-size)",
        "fontWeight": "var(--text-heading-4-weight)",
        "lineHeight": "var(--text-heading-4-leading)"
      },
      "level:5": {
        "fontFamily": "var(--font-family-heading)",
        "fontSize": "var(--text-heading-5-size)",
        "fontWeight": "var(--text-heading-5-weight)",
        "lineHeight": "var(--text-heading-5-leading)"
      },
      "level:6": {
        "fontFamily": "var(--font-family-heading)",
        "fontSize": "var(--text-heading-6-size)",
        "fontWeight": "var(--text-heading-6-weight)",
        "lineHeight": "var(--text-heading-6-leading)"
      },
      "type:display-1": {
        "fontFamily": "var(--font-family-heading)",
        "fontSize": "var(--text-display-1-size)",
        "lineHeight": "var(--text-display-1-leading)"
      },
      "type:display-2": {
        "fontFamily": "var(--font-family-heading)",
        "fontSize": "var(--text-display-2-size)",
        "lineHeight": "var(--text-display-2-leading)"
      },
      "type:display-3": {
        "fontFamily": "var(--font-family-heading)",
        "fontSize": "var(--text-display-3-size)",
        "lineHeight": "var(--text-display-3-leading)"
      }
    },
    "text": {
      "type:body": {
        "fontFamily": "var(--font-family-body)",
        "fontSize": "var(--text-body-size)",
        "lineHeight": "var(--text-body-leading)"
      },
      "type:large": {
        "fontFamily": "var(--font-family-body)",
        "fontSize": "var(--text-large-size)",
        "lineHeight": "var(--text-large-leading)"
      },
      "type:label": {
        "fontFamily": "var(--font-family-body)",
        "fontSize": "var(--text-label-size)",
        "lineHeight": "var(--text-label-leading)"
      },
      "type:code": {
        "fontFamily": "var(--font-family-code)",
        "fontSize": "var(--text-code-size)",
        "lineHeight": "var(--text-code-leading)"
      },
      "type:supporting": {
        "fontFamily": "var(--font-family-body)",
        "fontSize": "var(--text-supporting-size)",
        "lineHeight": "var(--text-supporting-leading)"
      },
      "type:display-1": {
        "fontFamily": "var(--font-family-heading)",
        "fontSize": "var(--text-display-1-size)",
        "lineHeight": "var(--text-display-1-leading)"
      },
      "type:display-2": {
        "fontFamily": "var(--font-family-heading)",
        "fontSize": "var(--text-display-2-size)",
        "lineHeight": "var(--text-display-2-leading)"
      },
      "type:display-3": {
        "fontFamily": "var(--font-family-heading)",
        "fontSize": "var(--text-display-3-size)",
        "lineHeight": "var(--text-display-3-leading)"
      }
    }
  },
  __onDark: {
    "tokens": {
      "color-scheme": "dark",
      "--color-text-primary": "var(--color-on-dark)",
      "--color-icon-primary": "var(--color-on-dark)",
      "--color-accent": "var(--color-on-dark)"
    }
  },
  __onLight: {
    "tokens": {
      "color-scheme": "light",
      "--color-text-primary": "var(--color-on-light)",
      "--color-icon-primary": "var(--color-on-light)",
      "--color-accent": "var(--color-on-light)"
    }
  },

};
